import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProjectMaterials = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 79,
	height: 71,
	viewBox: "0 0 79 71",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M39.4996 40.0468L0.396484 20.1416L39.4996 0.337402L78.7038 20.1416L39.4996 40.0468ZM39.4996 55.3041L2.82148 36.7124L5.0444 35.4999L39.4996 52.778L74.0559 35.4999L76.3798 36.7124L39.4996 55.3041ZM39.4996 70.6624L2.82148 51.9697L5.0444 50.7572L39.4996 68.1364L74.0559 50.7572L76.3798 51.9697L39.4996 70.6624ZM39.4996 37.5207L74.1569 20.1416L39.4996 2.86344L5.0444 20.1416L39.4996 37.5207Z",
		fill: "#152A58"
	})
});
export default SvgProjectMaterials;
